import React, { useContext } from "react";
import PropTypes from "prop-types";
import styles from "./style/AssignmentItem.module.css";
import clsx from "clsx";
import { AssignmentFormModal } from "@components/AssignmentFormModal";
import { CurriculumContext } from "@pages/EditingCoursePage/CurriculumTab";
import { ConfirmModal } from "@components/ConfirmModal";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";

const AssignmentItem = ({ assignmentData, sectionId }) => {
  // state

  // variables
  // logics before hooks

  // hooks

  const { handleDeleteAssignment, handleEditAssignment } =
    useContext(CurriculumContext);
  // logics

  // UI partials
  const addprocessingList = useSelector(
    (state) => state.course.addAssignment.processingList
  );
  // const updateProcessingList = useSelector(
  //   (state) => state.course.updateAssignment.processingList
  // );

  const addAssignmentProcessing = addprocessingList.find(
    (assignment) => assignment.id == assignmentData.id
  );
  // const updateAssignmentProcessing = updateProcessingList.find(
  //   (assignment) => assignment.id == assignmentData.id
  // );
  // effects

  // render
  return (
    <div
      className={clsx(
        styles.container,
        "py-2 px-3",
        assignmentData.isDeleted ? "d-none" : null
      )}
    >
      <div className="d-flex align-items-center">
        <i className="bi bi-clipboard2-check-fill"></i>
        <span className={clsx("mx-2", styles.title)}>
          {assignmentData.title}
        </span>
        {addAssignmentProcessing?.processing ? (
          <Spinner animation="border" size="sm" variant="danger" />
        ) : null}
        {/* {(addAssignmentProcessing?.isSuccess == true ||
          updateAssignmentProcessing?.isSuccess == true) && (
          <i className="bi bi-check-circle-fill text-success"></i>
        )} */}
        {addAssignmentProcessing?.isSuccess == false && (
          <i className="bi bi-x-circle-fill text-danger"></i>
        )}
        <AssignmentFormModal
          onSubmit={(newAssignment) =>
            handleEditAssignment(sectionId, newAssignment)
          }
          initialValues={assignmentData}
        >
          <button className="ml-2 opacity-0">
            <i className="bi bi-pencil-square"></i>
          </button>
        </AssignmentFormModal>

        <ConfirmModal
          onSubmit={() => handleDeleteAssignment(sectionId, assignmentData.id)}
          title={"Delete assignment"}
          body={"Do you really want to delete this assignment?"}
          submitButton={"Delete"}
        >
          <button type="button" className="ml-2 opacity-0">
            <i className="bi bi-trash-fill"></i>
          </button>
        </ConfirmModal>
      </div>
      <div>
        <button className="opacity-0">
          <i className="bi bi-list"></i>
        </button>
      </div>
    </div>
  );
};

/* required: display name */
AssignmentItem.displayName = "AssignmentItem";

/* required: props types */
AssignmentItem.propTypes = {};

/* required: default props */
AssignmentItem.defaultProps = {};

export { AssignmentItem };
